"use client";
import React from "react";

interface Props {
  mobile?: boolean;
  showBuyNow?: boolean;
}

const AddToCartSkeleton: React.FC<Props> = ({ mobile, showBuyNow }) => {
  if (mobile) {
    return (
      <div className="d-flex flex-column gap-2 w-100">
        {/* Add to Cart Button Skeleton */}
        <div
          className="skeleton-rect"
          style={{ width: "100%", height: 48, borderRadius: 8 }}
        />
        {/* Buy Now Button Skeleton */}
        {showBuyNow && (
          <div
            className="skeleton-rect"
            style={{ width: "100%", height: 48, borderRadius: 8 }}
          />
        )}
      </div>
    );
  }

  return (
    <div className="d-flex gap-3 w-100">
      {/* Add to Cart Button Skeleton */}
      <div
        className="skeleton-rect"
        style={{ flex: 1, height: 56, borderRadius: 8 }}
      />
      {/* Buy Now Button Skeleton */}
      {showBuyNow && (
        <div
          className="skeleton-rect"
          style={{ flex: 1, height: 56, borderRadius: 8 }}
        />
      )}
    </div>
  );
};

export default AddToCartSkeleton;
